import { Link } from 'react-router-dom';
import programas from '../data/programas';

const CardImagen = () => (
  <section className="programas-section" id="programas" aria-labelledby="programas-title">
    <div className="programas-heading">
      <p id="programas-title">Nuestros programas</p>
      <span></span>
      <h2>Elige el camino que quieres construir</h2>
    </div>

    <div className="programas-grid">
      {programas.map((programa) => (
        <article className="programa-card" key={programa.slug}>
          <div className="programa-card-visual">
            <img
              src={programa.imagen}
              alt={`Afiche del programa Técnico Laboral en ${programa.titulo}`}
              loading="lazy"
              decoding="async"
              onError={(event) => { event.currentTarget.parentElement.hidden = true; }}
            />
          </div>
          <div className="programa-card-info">
            <p className="programa-card-categoria">Técnico Laboral</p>
            <h3>{programa.titulo}</h3>
            <p className="programa-card-dato">Duración: 3 semestres</p>
            <p className="programa-card-descuento">Descuentos anunciados: 15% y 20%</p>
            <Link
              className="programa-card-boton"
              to={`/formaciontecnicolaboral/${programa.slug}`}
            >
              Conoce Más <span aria-hidden="true">→</span>
            </Link>
          </div>
        </article>
      ))}
    </div>
  </section>
);

export default CardImagen;
